import { defineComponent as _defineComponent } from 'vue'
import { api } from "@/main";
import * as webauthnJson from "@github/webauthn-json";
import Card from "@/components/Card.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import { ref } from "vue";
import EditableTable from "@/components/EditableTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPasskeys',
  setup(__props) {

const showCreatePasskeyDialog = ref(false);

function startRegistration(form) {
  api.passkey.startRegistration(form.name).then(passkeyRequest => {
    const json = passkeyRequest.webauthnRequest;
    const credentialCreateOptions = JSON.parse(json);
    webauthnJson.create(credentialCreateOptions).then(publicKeyCredential => {
      api.passkey.finishRegistration(passkeyRequest.id, JSON.stringify(publicKeyCredential)).then(result => {
        showCreatePasskeyDialog.value = false
      })
    }, error => {
      console.dir(error);
      api.emitError(error);
    })
  });
  return new Promise(resolve => {
    resolve("");
  });
}

function startAssertion() {
  api.passkey.startAssertion().then(passkeyRequest => {
    const json = passkeyRequest.webauthnRequest;
    const credentialGetOptions = JSON.parse(json);
    webauthnJson.get(credentialGetOptions).then(publicKeyCredential => {
      api.passkey.finishAssertion(passkeyRequest.id, JSON.stringify(publicKeyCredential)).then(result => {
        console.dir(result);
      })
    }, error => {
      console.dir(error);
      api.emitError(error);
    })
  })
}


return { __sfc: true,showCreatePasskeyDialog, startRegistration, startAssertion, Card, DynamicForm, EditableTable }
}

})